<template>
  <div>
    <h1>Importadores</h1>
    <b-card>
      <b-table striped hover :items="recursos" :fields="fields">
        <template #cell(id)="{ index }">
          {{ index + 1 }}
        </template>

        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_delete="false"
            :view_edit="$can('oportunidade:edit')"
            edit_icon="file-import"
            edit_to="oportunidades_import_emendas"
          />
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";

export default {
  components: { Actions },
  data: () => ({
    recursos: [
      {
        id: "emenda",
        titulo: "Beneficios do Concedente e Emendas Parlamentares",
      },
    ],
  }),
  computed: {
    fields() {
      return [
        { key: "id", label: "COD", class: "col-1" },
        { key: "titulo", label: "Título" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
};
</script>

<style></style>
